import type { ErpModule, OrganizationFeatureDto } from '@/api/platform.api';
import { getModuleEntryByErpModule } from '@/config/moduleEntries';
import { LAUNCHER_ERP_MODULES, moduleDefaultRoutes } from '@/config/moduleDefaults';

export {
  MODULE_DEFAULT_API_PREFIXES,
  MODULE_DEFAULT_PERMISSION_MODULES,
  MODULE_SETTINGS_PATH,
  MODULE_SUBSCRIPTION_PATH,
  moduleDefaultRoutes,
  moduleDefaultApis,
  moduleDefaultPermissionModules,
  moduleAdminNavItems,
  getModuleAdminNavItems,
  moduleSettingsLink,
  moduleSubscriptionLink,
  moduleWorkspaceNavItems,
  moduleAdminPath,
  moduleAdminRoutes,
  dedupeNavItems,
  LEGACY_ORG_ADMIN_ROUTE_PREFIXES,
} from '@/config/moduleDefaults';

/** @deprecated Use moduleAdminRoutes per module */
export const MODULE_DEFAULT_ROUTE_PREFIXES = [
  ...new Set(LAUNCHER_ERP_MODULES.flatMap((m) => moduleDefaultRoutes(m))),
] as const;

/** @deprecated Use moduleAdminRoutes per module */
export const MODULE_WORKSPACE_ROUTE_PREFIXES = [
  '/org/workspace/settings',
  '/org/workspace/subscription',
  '/org/profile',
  '/org/employees',
  '/org/roles',
  '/org/administration',
] as const;

export function resolveWorkspaceModule(
  moduleParam: string | null | undefined,
  entryModule: ErpModule | null,
): ErpModule | null {
  if (moduleParam) {
    const entry = getModuleEntryByErpModule(moduleParam.toUpperCase());
    if (entry) return entry.erpModule;
  }
  return entryModule;
}

export function featuresForModule(
  features: OrganizationFeatureDto[],
  module: ErpModule,
): OrganizationFeatureDto[] {
  return features.filter((f) => f.module === module);
}
